export const BACKEND_API_URL = 'https://b3beciz.go.ro/server/api';
export const IMAGE_SERVER_URL_ORIGINAL = `https://b3beciz.go.ro/server/api/template/image/{templateId}`
export const IMAGE_SERVER_URL = `https://b3beciz.go.ro/server/api/template/image/{templateId}?height={height}`
